export default __webpack_public_path__ + "static/media/board.92ae42ae.png";